// Angular
import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
// RxJS
import {Subscription} from 'rxjs';

import {AuthService} from '../../../../core/ngrx/main/auth.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../core/ngrx';
import {AuthModel} from '../../../../core/models/main/auth.model';
import {configApp} from '../../../../core/configapp/config';
import {ParametresService} from '../../../../core/ngrx/app/parametres/parametres.service';

@Component({
	selector: 'kt-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
	// Public params
	loginForm: FormGroup;
	loading = false;
	codepin: boolean = false;
	debloquerRetour: string = '';
	erreurMsg: string = '';
	show_button: boolean = false;
	show_eye: boolean = false;


	nbreEssaiePin: number = 0;
	private subscriptions: Subscription[] = [];



	// Constructor
	constructor(
		private store: Store<AppState>,
		private router: Router,
		private authService: AuthService,
		private parametresService: ParametresService,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
	) {

	}


	/**
	 * On init
	 */
	ngOnInit(): void {


		this.initLoginForm();


	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.subscriptions.forEach(el => el.unsubscribe());
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initLoginForm() {
		// demo message to show
		this.loginForm = this.fb.group({
			email: [configApp.DEMO_EMAIL, Validators.required],
			password: [configApp.DEMO_PASSWORD, Validators.required]
		});
	}

	//Se connecter
	seconnecter() {
		const controls = this.loginForm.controls;
		/** check form */
		if (this.loginForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		this.loading = true;
		this.erreurMsg = '';
		this.authService.login(controls.email.value, controls.password.value).subscribe(
			(_data: AuthModel) => {
				if (_data) {
					if (_data.id) {
						this.authService.enregistrerLoginEnLocal(_data);
						// init data

						// 1 Charger les permissions
						// this.store.dispatch(new DemandeSession(_data.id));
						// this.subscriptions.push(this.store.pipe(select(selectSessionReponse)).subscribe(
						// 	(reponse: ReponseModel) => {
						// 		if (reponse.isRequestOk) {
						// 			this.loading = false;
						// 			this.cdr.detectChanges();
						// 			if (!reponse.isErreur) {
						// 				this.router.navigate([configApp.appPage + '/']);
						// 			}
						// 		}
						// 	}
						// ));

						// 2- charger Param societe
						this.parametresService.getParamSocieteFromServer();

						// 3 - charger Param collaborateur/utilisateur
						this.parametresService.getParamCollaborateurFromServer();

						//4- redireger vers page loading
						this.router.navigateByUrl('loading');

					} else {

						if (_data._erreur) {
							if (_data._erreur.numero == 2) {
								// compte vérouillé  ==> code PIN pour réactivé
								this.codepin = true;
							}
							this.erreurMsg = _data._erreur.message;
						}
						this.loading = false;
						this.cdr.detectChanges();
					}
				}
			}
		);
	}


	//debloquer compte verouille
	debloquer(pin: string) {

		const controls = this.loginForm.controls;
		this.loading = true;
		this.authService.debloquer(controls.email.value, pin).subscribe(
			(data: string) => {
				if (data) {
					if (data == '1') {
						this.codepin = false;
						this.erreurMsg = '';
					} else {
						this.erreurMsg = 'Le code de sécurité n\'est pas valide. Vueillez saisir un code valide !';
						this.nbreEssaiePin++;
					}

					if(this.nbreEssaiePin > 3){
						this.erreurMsg = 'Une erreur est survenue lors de la tentative de traitement de votre demande. Veuillez ressayer plus tard';
					}
					this.debloquerRetour = data;
					this.loading = false;
					this.cdr.detectChanges();
				}
			}
		);
	}

    showPassword() {
		this.show_button = !this.show_button;
		this.show_eye = !this.show_eye;
    }
}
